import React from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useTranslation } from "react-i18next"

import MarkAttendance from "../MarkAttendance"

const MarkAttendanceModal = ({
  isOpen,
  toggle,
  modalType,
  getAllData,
  selectedUuid,
  selectedItem,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      className=""
      backdrop="static"
    >
      <ModalHeader toggle={toggle}>
        {modalType === "MARK_ATTENDANCE"
          ? t("Mark Attendance")
          : modalType === "CREATE"
          ? t("Add Practical Training")
          : t("Update Practical Training")}
      </ModalHeader>
      <ModalBody>
        {modalType === "MARK_ATTENDANCE" && (
          <MarkAttendance
            selectedUuid={selectedUuid}
            selectedItem={selectedItem}
            getAllData={getAllData}
            toggle={toggle}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

export default MarkAttendanceModal
